"use client";

import { useToast } from "../../hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./toast.web";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
            variant={variant}
            data-testid={variant === "destructive" ? "toast-error" : "toast-success"}
          >
            <div className="grid gap-1">
              {title && (
                <ToastTitle
                  data-testid={
                    variant === "destructive" ? "toast-error-title" : "toast-success-title"
                  }
                >
                  {title}
                </ToastTitle>
              )}
              {description && (
                <ToastDescription
                  data-testid={
                    variant === "destructive"
                      ? "toast-error-description"
                      : "toast-success-description"
                  }
                >
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
